import { render, staticRenderFns } from "./ModuleRedirectView.vue?vue&type=template&id=c917efd6&"
import script from "./ModuleRedirectView.vue?vue&type=script&lang=js&"
export * from "./ModuleRedirectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports